module.exports = __webpack_public_path__ + "static/media/Icon-MusicDirector.fe0ba07b.png";